<template>
  <div class="book">
    <Spinner/>
    <router-view></router-view>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      book: {}
    }
  },
  created () {
    this.toggleSpinner()

    // Delete cookies on page in case some prevent Azure from loading
    const cookieUtil = require('@/utils/cookie')
    cookieUtil.deleteAllCookies()

    var promises = []

    promises.push(this.$store.dispatch('getBook', this.id))
    promises.push(this.$store.dispatch('setFavorites'))
    promises.push(this.$store.dispatch('getElements'))
    promises.push(this.$store.dispatch('getUrls'))
    promises.push(this.$store.dispatch('getNotes'))

    Promise.all(promises).then(() => {
      this.toggleSpinner()
    })
  },
  methods: {
    ...mapActions(['toggleSpinner'])
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  components: {
    Spinner
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/book/Book.vue